<div
  class="toast {{ type() }}"
  [class.show]="show()"
  (click)="close()"
  tabindex="0"
  (keyup.enter)="close()">
  <div class="header-container">
    <div class="left-container">
      <span class="icon" style="mask-image: url('/assets/icons/{{ icon() }}.svg'); -webkit-mask-image: url('/assets/icons/{{ icon() }}.svg')"></span>
      <h2 class="title {{ type() }}">{{ title() }}</h2>
    </div>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon {{ type() }}" (click)="close()" (keyup.enter)="close()" tabindex="0">
      <path d="M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
  <p class="message">
    {{ message() }}
    @if (action(); as action) {
      <button type="button" class="toast-action" (click)="triggerAction($event)">{{ action.label }}</button>
    }
  </p>
</div>
